// packages/web/src/api/day-breaks/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { dayBreaksGet } from "../generated/sdk.gen.ts";
import { queryKeys } from "../query-keys.ts";

export const dayBreakByUserDateOptions = (userId: string, date: string) =>
  queryOptions({
    queryKey: queryKeys.dayBreaks.byUserDate(userId, date),
    queryFn: async () => {
      const { data, error } = await dayBreaksGet({ path: { userId, date } });
      if (error) throw error;
      return data;
    },
    enabled: !!userId && !!date,
  });
